import { CommonRequest, CommonResponse, Method, ServiceName } from 'models/common/RestApi';
import { SetupProjectStatus } from 'models/setup/home/SetupProjectStatus';
import { callApi } from 'utils/ApiUtil';

/**
 * Home Project List
 */
export const findSetupProjectStatusList = async () => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/setup/project-status`,
    serviceName: ServiceName.ELM_BE,
  };

  const response: CommonResponse<[]> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as SetupProjectStatus[];
};
